import { createRequest } from 'mk-biz-pc'
import streamSaver from 'streamsaver'
import { message } from 'mk-pc'

const coreApi = createRequest('core')

/**
 * 获取文件code
 * @param id
 * @param type
 * @returns
 */
export const getFileCode = (id: string, type: string, bizType: string) => {
  return coreApi('GET /approval/file-code', { params: { id, type, bizType } })
}

/**
 * 下载文件
 * @param id
 * @param filename
 */
export const downloadFile = (id: string, fileName: string) => {
  window
    .fetch(`${process.env.API_CORE_URL}/file/download/${id}`, {
      headers: {
        Authorization: window.localStorage.getItem('token') || ''
      }
    })
    .then((res) => {
      if (!res.ok || res.status !== 200) {
        return message.error('下载失败')
      }

      const readableStream = res.body

      const fileStream = streamSaver.createWriteStream(fileName, {
        size: Number(res.headers.get('content-length'))
      })

      if (window.WritableStream && readableStream?.pipeTo) {
        return readableStream?.pipeTo(fileStream).then((res) => {
          console.log('done writeen')
        })
      }

      const writer = fileStream.getWriter()
      const reader = res.body?.getReader()

      const pump = () =>
        reader?.read().then((res) => {
          res.done ? writer.close() : writer.write(res.value).then(pump)
        })
      pump()
    })
}
